export class FilePathCollection { 
    LinkType: number; 
    FileName: string; 
}
